var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GFL-Marketing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GFL---Fighters",
    transform: "translate(-1656, -2294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0, 2125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1657, 170)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-11",
    stroke: "#DEC371",
    strokeWidth: 2,
    fill: "#1A1A1A",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3397439,12.0208431 C26.6961259,12 28.0425649,12.0108384 29.3881753,12 C29.4329185,13.6932902 30.1156667,15.2173348 31.2019322,16.3461949 L31.2002751,16.3445274 C32.3693984,17.4041886 33.8906673,18.0911759 35.5677089,18.207897 L35.5909091,18.2095645 L35.5909091,22.4081905 C34.0066682,22.3681718 32.5168853,22.0005002 31.1737606,21.3685387 L31.241704,21.3968852 C30.5920989,21.0825719 30.0427518,20.7599213 29.5207478,20.3997532 L29.5638338,20.4280998 C29.5538909,23.4703528 29.5737767,26.5126059 29.5431194,29.5440205 C29.4577758,31.0889082 28.9473719,32.497899 28.128737,33.6742813 L28.1453085,33.6484359 C26.7764979,35.6210231 24.5592236,36.915794 22.0378612,36.9924965 L22.0262611,36.9924965 C21.924346,36.9974988 21.8042022,37 21.6832299,37 C20.2497902,37 18.9099798,36.5981458 17.7681995,35.9003201 L17.8013426,35.9194958 C15.7232694,34.6614087 14.2898297,32.5087374 14.0246848,30.005069 L14.0213705,29.9708864 C14.000656,29.4498099 13.9907131,28.9287334 14.0114275,28.4184953 C14.4174307,24.4341359 17.7350564,21.3518642 21.7677448,21.3518642 C22.2209769,21.3518642 22.6650946,21.3910492 23.0967837,21.4652505 L23.0503833,21.4585807 C23.0710978,23.0001334 23.0089544,24.5425198 23.0089544,26.0840726 C22.658466,25.956513 22.25412,25.8823117 21.8323739,25.8823117 C20.2845904,25.8823117 18.9679802,26.8777763 18.4807765,28.2675915 L18.4733193,28.2926032 C18.3631184,28.6486027 18.2993179,29.0579604 18.2993179,29.4814914 C18.2993179,29.6532382 18.3100894,29.8233175 18.3299753,29.990062 L18.3283181,29.9700527 C18.603406,31.6758487 20.0567315,32.9631161 21.8091737,32.9631161 C21.8597169,32.9631161 21.9094316,32.9622824 21.9591463,32.9597812 L21.9516891,32.9597812 C23.1638985,32.9230974 24.2161924,32.2669579 24.8111112,31.2973388 L24.819397,31.2823318 C25.0406273,30.972187 25.1922571,30.5970119 25.2428003,30.1893217 L25.2436289,30.1776496 C25.3472011,28.3126126 25.3057722,26.4584139 25.3157152,24.5933769 C25.3256581,20.3947509 25.3057722,16.2061295 25.3364296,12.0183419 L25.3397439,12.0208431 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok-icon.73c341c961a29738f77c4c0ec0589000.svg";
export { ForwardRef as ReactComponent };